import {
  styled,
  ListItem,
  ListItemButton,
  ListItemIcon,
  ListItemText,
} from '@mui/material';

export const FormattedQuestion = styled('div')({
  width: 20,
  height: 20,
  display: 'flex',
  textAlign: 'center',
  flexDirection: 'column',
  justifyContent: 'center',
  fontSize: 20,
  fontFamily: 'Inter, sans-serif',
  fontWeight: 350,
});

export const KeyActionsTitleStyled = styled('h2')(({ theme }) => ({
  paddingTop: theme.spacing(4),
  paddingBottom: theme.spacing(4),
}));

export const ListItemStyled = styled(ListItem)(() => ({
  padding: 4,
}));

export const ListItemButtonStyled = styled(ListItemButton)(({ theme }) => ({
  border: `0.1rem solid ${theme.palette.grey[200]}`,
  borderRadius: theme.shape.borderRadius,
  backgroundColor: theme.palette.common.white,
  '&.MuiButtonBase-root': {
    padding: theme.spacing(3),
  },
  '&.Mui-disabled': {
    opacity: 1,
  },
}));

export const ListItemIconDefaultStyled = styled(ListItemIcon)({
  minWidth: 0,
  alignItems: 'center',
});

export const ListItemIconCircleStyled = styled(ListItemIcon)(({ theme }) => ({
  minWidth: 0,
  alignItems: 'center',
  borderRadius: 50,
  padding: theme.spacing(2),
  backgroundColor: theme.palette.primary.main,
  WebkitTextFillColor: theme.palette.common.white,
  fontSize: 20,
}));

export const ListItemTextStyled = styled(ListItemText)({
  margin: 0,
  marginLeft: 15,
});
